import EnvConfig from '@Config/env.config';
import axios from 'axios';
import { CenterAdapter } from '../../adapters/CenterAdapter';
import { ICenterType } from '../../types/ICenterType';

const ROOT_URL = EnvConfig.API_URL;

export async function getAddress(payload: ICenterType) {
    console.log('Payload: ', payload);
    const response = await axios.get(`${ROOT_URL}/centers`);
    return CenterAdapter.adapt(response.data);
}

export async function updateAddress(payload: ICenterType) {
console.log('Payload: ', payload);
const response = await axios.get(`${ROOT_URL}/center/address`);
return CenterAdapter.adapt(response.data);
}

export async function updateCenter(payload: ICenterType) {
    console.log('Payload: ', payload);
    const response = await axios.get(`${ROOT_URL}/center/center`);
    return CenterAdapter.adapt(response.data);
}

export async function updateMemo(payload: ICenterType) {
    console.log('Payload: ', payload);
    const response = await axios.get(`${ROOT_URL}/center/memo`);
    return CenterAdapter.adapt(response.data);
}

export async function updateCorrespondance(payload: ICenterType) {
    console.log('Payload: ', payload);
    const response = await axios.get(`${ROOT_URL}/center/correspondance`);
    return CenterAdapter.adapt(response.data);
}

export async function updateParameters(payload: ICenterType) {
    console.log('Payload: ', payload);
    const response = await axios.get(`${ROOT_URL}/center/parameters`);
    return CenterAdapter.adapt(response.data);
}

export async function updatePaymentSystem(payload: ICenterType) {
    console.log('Payload: ', payload);
    const response = await axios.get(`${ROOT_URL}/center/payment_system`);
    return CenterAdapter.adapt(response.data);
}


